


















import { Vue, Component, Prop } from 'vue-property-decorator'

@Component
export default class extends Vue {
  @Prop(String) private message!: string
  @Prop(String) private actionText!: string
  @Prop(String) private actionUrl!: string

  get hasLink (): boolean {
    return !!(this.actionText && this.actionUrl)
  }

  get hasAction (): boolean {
    return !!this.actionText && !this.actionUrl
  }
}
